import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * i18n plumbing, English-only (decision #3).
 *
 * The point of wiring this up now, before any Arabic exists, is that adding an
 * `ar` bundle later becomes a translation task rather than a refactor of every
 * screen. Combined with the RTL-capable Emotion cache in @radiology/ui and the
 * use of logical CSS properties (marginInlineStart, borderInlineEnd) throughout
 * the design system, switching direction is a runtime toggle.
 *
 * Rule for module phases: no user-visible string is hardcoded in a component.
 * Put it in locales/en.json and read it with useTranslation().
 */
export const defaultNS = 'common';

void i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  ns: [defaultNS],
  resources: { en: { common: en } },
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
});

export const i18n = i18next;

/** Locales the UI can switch to. `ar` is added when translations are supplied. */
export const SUPPORTED_LOCALES = [{ code: 'en', label: 'English', dir: 'ltr' as const }];
